import { auth } from '@/firebase/config'
import { clearAuthSessionCookie, clearLegacyAlumniIdTokenCookie, setAuthSessionCookie } from '@/lib/auth-session'
import { isFirebaseAuthError } from '@/lib/firebase-auth-errors'
import { signInWithEmailAndPassword, signOut, type UserCredential } from 'firebase/auth'

export interface AlumniEmailSignInResult {
	status: 'signed_in'
	userCredential: UserCredential
}

const LEGACY_FIREBASE_MFA_CODE = 'auth/legacy-firebase-mfa'

/**
 * Primer factor email/contraseña. MFA Alumni se valida después vía API y custom claim en el ID token.
 */
export async function signInEmailPasswordAlumni(email: string, password: string): Promise<AlumniEmailSignInResult> {
	try {
		const userCredential = await signInWithEmailAndPassword(auth, email, password)
		setAuthSessionCookie()
		clearLegacyAlumniIdTokenCookie()
		return { status: 'signed_in', userCredential }
	} catch (err: unknown) {
		if (isFirebaseAuthError(err) && err.code === 'auth/multi-factor-auth-required') {
			const legacy = new Error('Tu cuenta tiene MFA antiguo de Firebase. Un superusuario debe quitarlo en «Quitar MFA usuario» antes de usar Alumni.') as Error & { code?: string }
			legacy.code = LEGACY_FIREBASE_MFA_CODE
			throw legacy
		}
		throw err
	}
}

export function isLegacyFirebaseMfaError(err: unknown): boolean {
	return typeof err === 'object' && err !== null && 'code' in err && (err as { code: string }).code === LEGACY_FIREBASE_MFA_CODE
}

export async function authLogin(email: string, password: string): Promise<{ email: string | null; uid: string }> {
	const result = await signInEmailPasswordAlumni(email, password)
	return {
		email: result.userCredential.user.email,
		uid: result.userCredential.user.uid
	}
}

export async function authLogout(): Promise<void> {
	await signOut(auth)
	clearAuthSessionCookie()
}
